import { useContext, useEffect, useState } from "react";
import { OnboardingContext } from "../context/OnboardingContext";

export default function Finalize() {
  const { sessionId, setCurrentStep } = useContext(OnboardingContext);
  const [message, setMessage] = useState("Finalizing your registration…");

  useEffect(() => {
    async function finalize() {
      try {
        const res = await fetch("/api/admin-onboarding/finalize", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId })
        });

        const data = await res.json();

        if (data.error) {
          setMessage("An error occurred while finalizing your registration.");
          return;
        }

        // ⭐ Move to the final confirmation screen
        setCurrentStep("completed");

      } catch (err) {
        setMessage("An unexpected error occurred.");
      }
    }

    finalize();
  }, [sessionId, setCurrentStep]);

  return <div>{message}</div>;
}